// extracted by mini-css-extract-plugin
module.exports = {"loader":"ExcelDownloadApp_loader__SpD0A","load3":"ExcelDownloadApp_load3__uCqqp"};